import { composeWithDevTools } from '@redux-devtools/extension';
import * as React from 'react';
import { createRoot } from 'react-dom/client';
import Modal from 'react-modal';
import { Provider as ReduxProvider } from 'react-redux';
import { applyMiddleware, createStore } from 'redux';
import thunk from 'redux-thunk';

import { openChat, reducer } from '../state';
import Chat from './Chat';

export default function init() {
    const store = createStore(
        reducer,
        composeWithDevTools(applyMiddleware(thunk)),
    );

    const elem = document.getElementById('path-group-data');
    const id = JSON.parse(elem.innerHTML)['path_group_id'];

    document.querySelector('body').addEventListener('tm-open-chat', () => store.dispatch(openChat()));

    const container = document.getElementById('chat-holder');
    Modal.setAppElement(container);
    const root = createRoot(container);
    root.render(
        <ReduxProvider store={store}>
            <Chat pathGroupId={id} />
        </ReduxProvider>,
    );
}
